import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmedButton } from '@a-type/ui';
import { useHasServerAccess } from '../hooks/graphql.js';
export function ResetToServer({ client, }) {
    const canSync = useHasServerAccess();
    if (!canSync)
        return null;
    return (_jsx(ConfirmedButton, { emphasis: "primary", color: "attention", confirmText: "This will reset your local data to the server's version.", onConfirm: () => {
            client.__dangerous__resetLocal();
        }, children: "Reset local data" }));
}
//# sourceMappingURL=ResetToServer.js.map